import { render, staticRenderFns } from "./KeywordAnalytics.vue?vue&type=template&id=740cd017&scoped=true"
import script from "./KeywordAnalytics.vue?vue&type=script&lang=js"
export * from "./KeywordAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740cd017",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('740cd017')) {
      api.createRecord('740cd017', component.options)
    } else {
      api.reload('740cd017', component.options)
    }
    module.hot.accept("./KeywordAnalytics.vue?vue&type=template&id=740cd017&scoped=true", function () {
      api.rerender('740cd017', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/KeywordAnalytics.vue"
export default component.exports